import { Component, ElementRef, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { Ng1StateProxy } from "@gtmhub/core/routing";
import { localize } from "@gtmhub/localization";
import { MentionPopoverUser } from "./mention-popover.models";

@Component({
  selector: "ui-mention-popover",
  templateUrl: "./mention-popover.component.html",
  styleUrls: ["./mention-popover.component.less"],
  encapsulation: ViewEncapsulation.None,
})
export class MentionPopoverComponent {
  @Input() public user: MentionPopoverUser;
  @Input() public sourceMentionEl: ElementRef;
  @Output() public closed = new EventEmitter<boolean>();
  public profileBtnLabel: string = localize("view_profile");

  constructor(private ng1StateProxy: Ng1StateProxy) {}

  /**
   * Trigger when clicking outside
   */
  public changePopoverState(value): void {
    if (!value) {
      this.close();
    }
  }

  public close(): void {
    this.user = null;
    this.sourceMentionEl = null;
    this.closed.emit(true);
  }

  public isVisible(): boolean {
    return this.user != null && this.sourceMentionEl != null;
  }

  public openProfile(): void {
    this.ng1StateProxy.go("gtmhub.employees.employee", { employeeId: this.user.id });
  }
}
